import { inject, Injectable } from "@angular/core";
import { maintenance } from "src/app/support/maintenance";
import { ErrorCodes } from "src/app/modules/maintenance/error-codes";
import { Router } from "@angular/router";
import { lastValueFrom } from "rxjs";
import { ConfigurationBackend } from "src/app/backend/api/configuration.backend";
import { BootstrapService } from "src/app/modules/bootstrap/bootstrap.service";

@Injectable()
export class ProvideBillingConfigurationGuard {
  private readonly router = inject(Router);
  private readonly bootstrapService = inject(BootstrapService);
  private readonly configurationBackend = inject(ConfigurationBackend);

  async canActivate(): Promise<boolean> {
    try {
      const configuration = await lastValueFrom(
        this.configurationBackend.loadBilling()
      );

      this.bootstrapService.setCurrentBillingConfiguration(configuration);
    } catch (ex) {
      maintenance(this.router, { code: ErrorCodes.ERR_006 });
    }

    return true;
  }
}
